import {observable} from 'mobx';
import {construct, createArrayInstance, createInstance, ModelProperties} from '../utils';

import {LocaleHint} from './locale-hint';
import {WebLocaleCategory} from './web-locale-category';
import {WebLocaleContent} from './web-locale-content';

export class WebLocaleKey {
    @observable id!: number;

    @observable name!: string;

    @observable whitespaces: boolean = true;

    @observable charLimit: number = 0;

    @observable enabled: boolean = true;

    @observable hintId?: number;

    @observable categoryId!: number;

    @observable hint?: LocaleHint;

    @observable category?: WebLocaleCategory;

    @observable content?: WebLocaleContent[];

    constructor(key?: ModelProperties<WebLocaleKey>) {
        if (key) {
            construct(this, key);
            this.hint = createInstance(LocaleHint, key.hint);
            this.category = createInstance(WebLocaleCategory, key.category);
            this.content = createArrayInstance(WebLocaleContent, key.content);
        }
    }
}